import { COMPANY_DATA } from "../constants/action-types";
import { uploadActions } from "./base-upload-reducers";

export const companyDataUpload = uploadActions(COMPANY_DATA);
